// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DebugDetails__debugDetails___37Zqi{height:100%;padding:8px;background:#fff;overflow-y:auto}.DebugDetails__debugDetails___37Zqi span{font-size:14px}.DebugDetails__debugDetails___37Zqi>ul{margin:0 !important;padding-bottom:40px !important;background:#fff !important}.DebugDetails__debugDetailsLoader___3l9tw{height:calc(100% - 16px);width:100%;position:relative}.DebugDetails__debugDetailsLoader___3l9tw>div{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}\n", ""]);
// Exports
exports.locals = {
	"debugDetails": "DebugDetails__debugDetails___37Zqi",
	"debugDetailsLoader": "DebugDetails__debugDetailsLoader___3l9tw"
};
module.exports = exports;
